import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const data = localStorage.getItem("user");

  if (!data) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
